module.exports = __webpack_public_path__ + "static/media/section-3.c2fe8598.png";